<crm-single-select
  #singleSelectComponent
  [options]="budgetCodes"
  [(selectedItem)]="_selectedBudgetCode"
  (selectedItemChange)="onSelectChange($event)"
  [label]="labelInput ? 'КБК' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="43"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  [showClear]="showClear"
  filterBy="name,code">
  <ng-template
    #itemTemplate
    let-code="item">
    <ng-container *ngIf="toCode(code) as code">
      <p class="font-medium text-gray-500">
        <span [innerHTML]="highlightMatchText(code.code) | safeHtml"></span>
      </p>
      <p class="font-medium">{{ code.name }}</p>
      <p class="font-bold text-green-500">{{ code.budgetRevenueAdmin?.name }}</p>
    </ng-container>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
